'use strict';

var _ = require('lodash');
var GridExpandButtonController = function GridExpandButtonController($scope, $rootScope, gridMaximizeConstants) {
  $scope.onButtonClick = function () {
    $scope.isGridExpanded = !$scope.isGridExpanded;
    $scope.gridId.indexOf('flight-analysis') !== -1 ? $rootScope.$broadcast('gridExpand:flight-analysis', $scope.gridId) : $rootScope.$broadcast('gridExpand:' + $scope.gridId);
  };
  $scope.load = function () {
    if (_.isUndefined($scope.screenState)) {
      return false;
    }
    switch ($scope.gridId) {
      case 'market-demand-analysis':
        $scope.isGridExpanded = $scope.screenState.isMarketAnalysisGridExpanded;
        break;
      case 'market-product-group-analysis':
        $scope.isGridExpanded = $scope.screenState.isMarketProductGridExpanded;
        break;
      case 'service-demand-analysis':
        $scope.isGridExpanded = $scope.screenState.isServiceGridExpanded;
        break;
      case 'online-logit-calibration-review':
        $scope.isGridExpanded = $scope.screenState.isOnlineLogitGridExpanded;
        break;
      default:
        var maximizeFlag = gridMaximizeConstants.GRID_KEY_TO_MAXIMIZE_FLAG_MAPPING[$scope.gridId];
        if (!_.isUndefined(maximizeFlag)) {
          $scope.isGridExpanded = $scope.screenState[maximizeFlag];
          $scope.screenState.isFlightAnalysisGridExpanded = $scope.screenState[maximizeFlag];
        }
    }
  };
  $scope.load();
};
GridExpandButtonController.$inject = ['$scope', '$rootScope', 'GridMaximizeConstants'];
module.exports = GridExpandButtonController;